/*
 * Copyright © Scale Microgrid Solutions Operating, LLC [2023].
 * All rights reserved.
 *
 * SPDX-FileCopyrightText: ©2023 Scale Microgrid Solutions Operating, LLC <legal@scalemicrogrids.com>
 */

import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import WeatherIcon from "../WeatherIcon";
import { getWeatherDescriptionFromWMO } from "../../lib/weatherUtils";
import { formatTemperature } from "../Graphs/Logic/formatUtils";
import { HourlyWeatherData } from "../../lib/Types";

interface Props {
  weatherData?: Partial<HourlyWeatherData>;
  size?: number;
  fontSize?: number;
}

const WeatherDisplay: React.FC<Props> = ({ weatherData, size = 20, fontSize = 14 }) => {
  return (
    <Tooltip
      title={
        weatherData?.weather_code !== null && weatherData?.weather_code !== undefined
          ? getWeatherDescriptionFromWMO(weatherData?.weather_code)
          : ""
      }
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <WeatherIcon size={size} weatherCode={weatherData?.weather_code} />
        <Typography
          sx={{ fontSize: `${fontSize}px`, marginLeft: weatherData?.temperature_2m ? 0 : ".75px" }}
          color={weatherData?.temperature_2m ? "secondary" : "grey"}
        >
          {formatTemperature(weatherData?.temperature_2m)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default WeatherDisplay;
